import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NewEventsInterface } from "interfaces/interfaces-data";
const initialPayload: NewEventsInterface | null = null;

interface AgendaEventState {
  event: NewEventsInterface | null;
}

const agendaEvent = createSlice({
  name: "agenda-event",
  initialState: { event: initialPayload } as AgendaEventState,
  reducers: {
    addEventDetails: (state, action: PayloadAction<NewEventsInterface>) => {
      state.event = action.payload;
    },
  },
});

export const { addEventDetails } = agendaEvent.actions;
export default agendaEvent.reducer;
